import { render, staticRenderFns } from "./CloudinaryImage.vue?vue&type=template&id=1322a9af&lang=pug&"
import script from "./CloudinaryImage.vue?vue&type=script&lang=js&"
export * from "./CloudinaryImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports